module.exports = __webpack_public_path__ + "img/11.aa2e5e5e.jpg";